import React from 'react';
import { InfoIconTooltip } from '../../../components/icons/InfoIconTooltip';
import { asoTooltips, AsoTooltipKey } from './asoTooltips';

interface AsoTooltipProps {
  tooltipKey: AsoTooltipKey;
  style?: React.CSSProperties;
}

const AsoTooltip: React.FC<AsoTooltipProps> = ({ tooltipKey, style }) => {
  const content = asoTooltips[tooltipKey];

  return <InfoIconTooltip content={content} style={style} />;
};

export default AsoTooltip;
